import React, {useMemo, useState} from 'react';
import {useParams} from 'react-router-dom';

import {loadRule, saveRule, useRulesData} from "./data-api";
import config from '../../shared/config';

import {parseConfig, Form, Display, FilterDisplay, RatesControls, Alert} from "./shared";

function EditRule() {
	let {ruleId} = useParams();
	let [saving, setSaving] = useState(false);
	let [loading, ruleData, setData] = useRulesData(async () => {
		let data = await loadRule(ruleId);
		return Object.assign({ruleId}, data);
	});

	let cfg = config.get('ServiceConfiguration', {});
	let {filterSelectorsProps, rateControlsProps} = useMemo(() => parseConfig(cfg), [cfg]);

	if (loading) {
		return (
			<Alert icon="folder-o">
				Loading the Rule data from the Central Configuration Service
			</Alert>
		);
	}

	if (saving) {
		return (
			<Alert icon="save">
				Saving the Rule data to the Central Configuration Service
			</Alert>
		)
	}

	return (
		<div className="cm-edit-rule-form">
			<h2>Edit Rule</h2>
			<Form values={ruleData} onSubmit={
				(e, state) => {
					console.debug('Submitting...');
					let rule = state.getValues();
					let {ruleId} = rule;
					delete rule.ruleId;
					setSaving(true);
					(async () => {
						await saveRule(ruleId, rule);
						setSaving(false);
						setData(null);
					})();
				}
			}>
				<Display label="Rule identifier"><var>{ruleId}</var></Display>
				<Display label="Display name">{ruleData.displayName}</Display>

				<h3>Filters</h3>
				{filterSelectorsProps.map(props => <FilterDisplay key={props.key} {...props}/>)}

				{rateControlsProps.map(props => <RatesControls key={props.key} {...props}/>)}

				<div>
					<button type="submit" className="btn btn-primary">Save</button>
				</div>
			</Form>
		</div>
	);
}


export default EditRule;